import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext({ darkMode: true });

const syncUserTheme = () => {
  const userDataRaw = localStorage.getItem('userData');
  if (!userDataRaw) return;

  try {
    const userData = JSON.parse(userDataRaw);
    if (userData.theme !== 'dark') {
      userData.theme = 'dark';
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  } catch (_) {
    // ignore invalid userData
  }
};

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    const root = document.documentElement;
    document.body.classList.add('dark-theme');
    root.classList.add('dark-theme');
    localStorage.setItem('theme', 'dark');
    syncUserTheme();
  }, []);

  return (
    <ThemeContext.Provider value={{ darkMode: true }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export const useAppTheme = () => {
  const { darkMode } = useTheme();
  return darkMode ? 'dark' : 'light';
};
